import React, { Component } from 'react';
import { IonSegment, IonSegmentButton, IonLabel, IonIcon, IonContent } from '@ionic/react';
import './index.css';
import { isDefined } from '../../lib/utils';
// import { starOutline } from 'ionicons/icons'
import { withTranslation } from '../../lib/translate';
import loyalty from '../../assets/images/loyalty.svg';
import Slider, { Slide } from '../slider';

class SwipableTabs extends Component {
  constructor(props) {
    super(props);
    const { defaultTab } = this.props;
    this.state = {
      selectedTab: defaultTab || 0,
      swiper: null
    };
  }

  componentDidMount() {
    if (
      this.props.history &&
      this.props.history.state &&
      this.props.history.state.tab === 'order'
    ) {
      this.segmentChanged(1);
    }
  }

  componentDidUpdate(prevProps,prevState) {
    if (this.props.history && prevProps.history.state !== this.props.history.state) {
      // fix: redirect to the scan tab if user is located in 'loyalty' page but on the first tab
      // and that he clicks on scan icon in header
      if (this.props.history.state?.tab === 'scan') {
        this.segmentChanged(1);
      } else if (
        this.props.history &&
        this.props.history.state &&
        this.props.history.state.tab === 'points'
      ) {
        this.segmentChanged(0);
      }
    }
    if((prevState.swiper !== this.state.swiper) && this.props?.history?.state?.tab === 'order'){
      this.segmentChanged(1);
    }
  }

  segmentChanged = (value) => {
    this.setState({ selectedTab: value });
    if (this.state.swiper) {
      this.state.swiper.slideTo(value);
    }
  };

  // On Segment change slide to the matching slide
  onSegmentChange = (ev) => {
    this.slideTo(ev.detail.value);
  };

  slideTo = (index) => {
    this.slides.slideTo(index);
  };

  // On Slide change update segment to the matching value
  onSlideDidChange = async () => {
    const index = await this.slides.getActiveIndex();
    this.clickSegment(index);
  };

  clickSegment = (index) => {
    this.segment.value = index;
  };

  render() {
    const { selectedTab } = this.state;
    const { available_balance, __, displayFooter, displayFooterTab } = this.props;
    const tabs = this.props.tabs || [];

    return (
      <div className="tabs">
        <div className="segment-holder">
          <IonSegment
            onIonChange={(e) => this.segmentChanged(e.detail.value)}
            value={selectedTab}
            mode="md"
          >
            {tabs.map((tab, index) => {
              const { label, icon } = tab;
              return (
                <IonSegmentButton key={index + '_segment'} value={index}>
                  {isDefined(icon) ? <IonIcon name={icon}></IonIcon> : null}
                  <IonLabel>{label || ''}</IonLabel>
                </IonSegmentButton>
              );
            })}
          </IonSegment>
        </div>
        <Slider
          settings={{
            loop: false,
            initialSlide: selectedTab,
            onSlideChange: (swiper) => this.segmentChanged(swiper.activeIndex),
            onSwiper: (swiper) => this.setState({swiper})
          }}
        >
          {tabs.map((tab, index) => {
            return (
              <Slide key={index + 'slide'} className={'slide-' + (index + 1)}>
                <IonContent>{tab.tabContent || null}</IonContent>
              </Slide>
            );
          })}
        </Slider>
        {displayFooter &&
        displayFooter === 'balance' &&
        isDefined(displayFooterTab) &&
        displayFooterTab + '' === selectedTab + '' ? (
          <div className="loyalty-bar">
            <div>
              <IonIcon className="loyalty-icon" slot="start" icon={loyalty} />
            </div>
            <div>
              <IonLabel color="dark">{__('Loyalty')}</IonLabel>
            </div>
            <div>
              <IonLabel color="dark" className="loyalty-balance">
                {available_balance} {__('Points Balance')}
              </IonLabel>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default withTranslation(SwipableTabs);
